export default __webpack_public_path__ + "static/media/3.23efe9b1.jpg";